<template>

<label class="vin-label__checkbox">
  <input
    class="vin-label__checkbox-input"
    type="checkbox"
    @change="check($event)"
  >
  <span class="vin-label__checkbox-mask"></span>
  <span
    class="vin-label__checkbox-text"
    v-html="labelText"></span>
  <span
    class="vin-label__error checkbox-error"
    v-if="errorText"
  >
    {{errorText}}
  </span>
</label>

</template>

<script>
export default {
  props: {
    labelText: String,
    errorText: String
  },
  methods: {
    check: function(e) {
      if (e.target.checked) {
        this.$emit("check", true);
        // console.log(e.target.value)
      } else  {
        this.$emit("check", false);
        // console.log(e.target.value)
      }
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/sass/partials/_sass-components.sass'
.vin-label__checkbox
  display: flex
  position: relative
  justify-content: center

  &-input
    display: none

    &:checked + .vin-label__checkbox-mask::before
      display: block

  &-mask
    width: 18px
    height: 18px
    border-radius: 4px
    border: 2px solid $grey
    display: inline-block
    margin-right: 8px
    flex-shrink: 0
    vertical-align: top
    position: relative

    &::before
      content: ''
      display: none
      width: 5px
      height: 8px
      border-bottom: 2px solid #ee2300
      border-right: 2px solid #ee2300
      transform: rotate(45deg)
      position: absolute
      left: 5px
      top: 2px


  &-text
    display: inline-block
    font-family: $text-font-book
    font-size: 16px
    font-weight: 300
    color: $black
    vertical-align: top
    +res('mob')
      text-align: left

</style>
